module.exports = __webpack_public_path__ + "static/media/LC-lck.770dfd0a.png";